module.exports = __webpack_public_path__ + "img/purple-3-squiggly-open.d82d32ab.svg";